export default "__VITE_ASSET__CodA8WBs__"